/* eslint-disable react/prop-types */
import { useState } from "react";

import {
  Box,
  Button,
  DialogContent,
  DialogContentText,
  Link,
  Stack,
} from "@mui/material";
import BasicTextField from "./basicTextField";
import DialogHeader from "./dialogHeader";
import translations from "../translations/index";

export default function WebsiteFormDialog({
  website,
  setWebsite,
  handleSearch,
  handleClose,
}) {
  const locale = window.authSettings ? window.authSettings.locale : "fr-FR";
  const translation = translations.getTranslations(locale);
  const [isError, setIsError] = useState(false);

  const howDoesItWork = {
    "fr-FR": "fr-fr/exhibitor-hub/comment-ca-marche.html",
    "en-GB": "en-gb/exhibitor-hub/how-does-it-work.html",
  };

  const buildHowDoesItWorkHref = () => {
    // Use origin + pathname to strip any hash fragment, then split on the
    // lowercase locale to handle URLs like /en-gb/ when locale is "en-GB".
    const { origin, pathname } = new URL(window.location.href);
    const baseUrl = (origin + pathname).split(locale.toLowerCase())[0];
    const path = howDoesItWork[locale] || howDoesItWork["en-GB"];
    return `${baseUrl}${path}`;
  };

  const handleChange = (event) => {
    setWebsite(event.target.value);
    setIsError(false);
    //console.log(website);
  };

  const handleClickSearch = () => {
    let securedUrl = website;
    if (!website.includes("https://") && !website.includes("http://")) {
      securedUrl = "https://" + website;
      setWebsite(securedUrl);
    }
    const expression =
      // eslint-disable-next-line no-useless-escape
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const regex = new RegExp(expression);
    if (securedUrl.match(regex)) {
      // Because the setter doesnt update in time, the Website has to be passed as an argument to the search function.
      handleSearch({ securedUrl });
    } else {
      setIsError(true);
    }
  };

  return (
    <>
      <DialogHeader
        title={translation.websiteDialog.title}
        handleClose={handleClose}
        isClosable={true}
      />
      <DialogContent sx={{ display: "flex", width: "-webkit-fill-available" }}>
        <Stack display={"flex"} width={"100%"}>
          <DialogContentText
            className="intelligent-profile-dialog-text"
            id="alert-dialog-description"
            marginTop={1}
            marginBottom={2}
            display={"flex"}
            //fontSize={"16px"}
          >
            {translation.websiteDialog.description}
          </DialogContentText>
          <BasicTextField
            labelText={translation.websiteDialog.inputLabel}
            value={website}
            setValue={handleChange}
            isError={isError}
            errorMsg={translation.websiteDialog.inputError}
          />
          <Box
            className="intelligent-profile-dialog-oblique"
            sx={{
              fontStyle: "oblique",
              mt: 1,
              mb: 1,
              //fontSize: "12px"
            }}
          >
            {translation.websiteDialog.userAgreement}
          </Box>
        </Stack>
      </DialogContent>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing={8}
        margin={3}
      >
        <Link
          href={buildHowDoesItWorkHref()}
          target="_blank"
          rel="noopener noreferrer"
          data-dtm="exhibitorHub_smartCompanion_help"
        >
          {translation.websiteDialog.howTo}
        </Link>
        <Button
          className="intelligent-profile-dialog-button"
          variant="contained"
          onClick={handleClickSearch}
          data-dtm="exhibitorHub_smartCompanion_launch"
        >
          {translation.websiteDialog.button}
        </Button>
      </Stack>
    </>
  );
}
